import axios from "../axios";

const api = {
  getDimensions(params, accessToken) {
    const config = {
      params: params,
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get("/dimensions", config).then(({ data }) => data);
  },

  // Multi-select cascade filter: params is { dimensionOne: "1,2", ... } — CSV
  // strings, not arrays. Axios 0.x serializes arrays as bracketed keys
  // (dimensionOne[]=1) which Spring won't bind; CSV binds to List<Long>.
  getFilterOptions(params, accessToken) {
    const config = {
      params: params,
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get("/dimensions/filter-options", config).then(({ data }) => data);
  },

  getDimensionsHierarchy(params, accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/dimensions/hierarchy?${params}`, config).then(({ data }) => data);
  },

  getEntityAppropriateDimensionItems(accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/dimension-items/entities-appropriate`, config).then(({ data }) => data);
  },

  getAssigneeTemplates(accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get("/organization-questionnaires/assignee-template", config).then(({ data }) => data);
  },

  updateAssigneeTemplate(data, accessToken) {
    const headers = { headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
    return axios.post("/organization-questionnaires/assignee-template", data, headers).then(({ data }) => data);
  },

  deleteAssigneeTemplate(id, accessToken) {
    const headers = { headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
    return axios.delete(`/organization-questionnaires/assignee-template?id=${id}`, headers).then(({ data }) => data);
  },
};

export default api;
